module.exports = __webpack_public_path__ + "static/favicon-32x32-e0c645e31de5903eca62a8b1882ddecd.png";